import React from "react";
import { TotalRecordsComponent } from "./TotalRecordsComponent";
import { DetailsComponent } from "./DetailsComponent";
import { ReportingFilter } from "./ReportingFilter";
import "./DataHolder.scss";

export const DataHolderComponent = ({
    caseCounts,
    filesCount,
    totalRecordsCount,
    closedEncountersCount,
    completedEncountersCount,
    emailsCount,
    encountersWithDNCCount,
    encountersWithDeclinedCount,
    encountersWithHPEDeterminedCount,
    encountersWithHPEEligibleCount,
    encountersWithMaxAttemptsCount,
    encountersWithMedicaidEligibleCount,
    encountersWithMissingInfoCount,
    inBounceCallsCount,
    outBounceCallsCount,
    textsCount,
    facilityComboBoxValues,
    dateRangeValue,
    coveragesCount,
    encountersWithRetroCheckCoverageCount,
    formattedFacility,
    submitFilter,
    selectedCustomerChanged,
    selectedCustomer,
    exportEncounters,
    lastMonthTotalCount,
    lastMonthFileCount,
    LastMonthCoverageCount
}) => {
var coveragePercentage =  totalRecordsCount>0?(coveragesCount / totalRecordsCount) * 100:0;
var lastMonthCoveragePercentage = lastMonthTotalCount>0?(LastMonthCoverageCount/lastMonthTotalCount)*100:0;
    return (
        <div>
            <div>
                <div className={"reporting_filter_div_inside_data_holder_component"}>
                    <ReportingFilter formattedFacilities={formattedFacility} 
                    submitFilter={submitFilter}
                     selectedCustomerChanged={selectedCustomerChanged}
                      selectedCustomer ={selectedCustomer}
                      exportEncounters={exportEncounters}/>
                </div>
            </div>

            <div className="total_records_component_details_component_set_top_margin">
                <div className={"box_alignment_total_records_component"}>
                    <TotalRecordsComponent title={filesCount} subTitle={"Files"} 
                    changeType={lastMonthFileCount!=0 ?filesCount -lastMonthFileCount :0}
                    changeValue={lastMonthFileCount!=0 ?((Math.abs( filesCount -lastMonthFileCount ))/lastMonthFileCount*100).toFixed(0)+'%':"-"} />
                    <TotalRecordsComponent title={totalRecordsCount} subTitle={"Records"}
                    changeType={lastMonthTotalCount!= 0 ?totalRecordsCount -lastMonthTotalCount :0} 
                    changeValue={lastMonthTotalCount!= 0 ?((Math.abs(lastMonthTotalCount - totalRecordsCount))/lastMonthTotalCount*100).toFixed(0)+'%':"-"}  />
                    <TotalRecordsComponent title={coveragesCount} subTitle={"Coverage Found"} 
                    changeType={LastMonthCoverageCount!= 0 ?(coveragesCount -LastMonthCoverageCount):0 }
                     changeValue={LastMonthCoverageCount!= 0 ?((Math.abs(coveragesCount -LastMonthCoverageCount))/LastMonthCoverageCount*100).toFixed(0)+'%':"-" }  />
                    <TotalRecordsComponent
                        title={totalRecordsCount > 0 && coveragesCount > 0 ?((coveragesCount / totalRecordsCount) * 100).toFixed(1)+"%":"0" + "%"}
                        subTitle={"Coverage Found %"}
                        changeType={lastMonthCoveragePercentage!= 0 ?coveragePercentage -lastMonthCoveragePercentage:0 } 
                        changeValue={lastMonthCoveragePercentage!= 0 ?((Math.abs(lastMonthCoveragePercentage -coveragePercentage))/lastMonthCoveragePercentage*100).toFixed(0) + "%":"-"}  
                    />
                </div>
                <div className="box_alignment_details_component">
                    <DetailsComponent
                        title={"Call Center"}
                        subTitle={"Activity Stats"}
                        title1={"Outbound Calls"}
                        title2={"Inbound Calls"}
                        title3={"Text Sent"}
                        title4={"Emails Sent"}
                        title1Count={outBounceCallsCount}
                        title2Count={inBounceCallsCount}
                        title3Count={textsCount}
                        title4Count={emailsCount}
                    />
                    <DetailsComponent
                        title={"Call To Action"}
                        subTitle={"For Customer"}
                        title1={"HPE Pending"}
                        title2={"Medicaid Pending"}
                        title3={"Retrocheck Coverage"}
                        title4={"Coverage Found"}
                        title1Count={encountersWithHPEEligibleCount}
                        title2Count={encountersWithMedicaidEligibleCount}
                        title3Count={encountersWithRetroCheckCoverageCount}
                        title4Count={coveragesCount}
                    />
                    <DetailsComponent
                        title={"CoverMe"}
                        subTitle={"Interview Stats"}
                        title1={"Cases Completed"}
                        title2={"Coverage Found"}
                        title3={"HPE Identified"}
                        title4={"Cases Closed"}
                        title1Count={completedEncountersCount}
                        title2Count={coveragesCount}
                        title3Count={encountersWithHPEDeterminedCount}
                        title4Count={closedEncountersCount}
                    />
                    <DetailsComponent
                        title={"Records Unable"}
                        subTitle={"To Process"}
                        title1={"Missing Info"}
                        title2={"Do Not Contact"}
                        title3={"Declined"}
                        title4={"Max Attempts"}
                        title1Count={encountersWithMissingInfoCount}
                        title2Count={encountersWithDNCCount}
                        title3Count={encountersWithDeclinedCount}
                        title4Count={encountersWithMaxAttemptsCount}
                    />
                </div>
            </div>
        </div>
    );
};
